export { pushDataLayer } from './gtm'
export * from './types'
